import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Self-hosted fonts: loading these from Google's CDN sent the IP address of every guest
// opening a menu to Google. Bundled locally, nothing leaves our own domain.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/playfair-display/600.css';
import '@fontsource/playfair-display/700.css';
import './index.css';
import './i18n';
import { registerServiceWorker } from './registerSW';
import { installPwaMetadata } from './pwa';

// Registered on every load, not only when someone turns push on: the browser needs an
// active worker before it will offer the app for installation.
registerServiceWorker();
// Adds the manifest, except on the guest menu domain
installPwaMetadata();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
